/* eslint-disable react-hooks/exhaustive-deps */
import { Box, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IS_SA } from "../../../../../config/appConfig";
import { AppRoutes } from "../../../../../constants/appRoutes";
import { InvestorStatus } from "../../../../../constants/investorStatus";
import { InvestorType, isCorporateType } from "../../../../../constants/investorType";
import { useInvestorDetails } from "../../../../../context/investorDetailContext";
import { buildLocalizeRoute } from "../../../../../helpers/languageHelper";
import { getUser } from "../../../../../services/authService";
import { UserService } from "../../../../../services/userService";
import { DialogWrapper } from "../../../../../shared/components/common/dialogWrapper";
import { TextWrapper } from "../../../../../shared/components/formUtilities/useTextWrapper";
import { InvestorDocuments } from "../../profile/documents";

export const PreventDepositDialog = ({ state = false, onClose = () => { } }) => {
  const userService = new UserService();
  const { investorDetails } = useInvestorDetails();
  const [isAllDocUploaded, setIsAllDocUploaded] = useState(false);
  const [isWinddownDocsUploaded, setIsWinddownDocsUploaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const isWinddown = getUser()?.status === InvestorStatus.WindDown;
  const { t } = useTranslation();

  const isKSAProfessional = () => {
    if (investorDetails) {
      return IS_SA && investorDetails?.investorType?.name === InvestorType.Professional;
    }
    return false;
  };

  useEffect(() => {
    if (investorDetails && investorDetails?.id) {
      if (IS_SA && (investorDetails?.investorType?.name === InvestorType.Retail || isCorporateType(investorDetails?.investorType?.name))) {
        setIsAllDocUploaded(true);
        setLoading(false);
      } else {
        getDocumentUploadStatus();
      }
    }
  }, [investorDetails]);

  useEffect(() => {
    if (isWinddown) {
      setLoading(true);
      getWinddownDocumentUploadStatus();
    }
  }, [state]);

  const getDocumentUploadStatus = () => {
    userService.getDocumentStatus().then(resp => {
      setIsAllDocUploaded(resp.data?.hasUploadedAllDocuments);
      setLoading(false);
    }).catch(err => {
      setLoading(false);
    });
  };

  const getWinddownDocumentUploadStatus = () => {
    userService.getDocumentStatus(true).then(resp => {
      setIsWinddownDocsUploaded(resp.data?.hasUploadedAllDocuments);
      setLoading(false);
    }).catch(err => {
      setLoading(false);
    });
  };

  const getTitle = () => {
    if (isWinddown) {
      return t('windDown');
    }
    if (isAllDocUploaded) {
      return t('approvalPending');
    } else {
      return t('depositNotAllowed');
    }
  };

  const getCommonTemplete = () => {
    return <>
      <TextWrapper classList="!text-center" text={t('winddownPopupText')} />
      <a onClick={() => {
        onClose(true);
      }} className="underline hover:no-underline !text-sm" href={buildLocalizeRoute(`${AppRoutes.Investor}/${AppRoutes.Profile}`)}>
        {t('uploadYourDocuments')}
      </a>
    </>;
  };

  const documentCompletedTemplate = () => {
    return <Box className='flex flex-col w-full items-center justify-center space-y-2'>
      <TextWrapper classList="!text-center" text={t('applicationCompletedPopupText')} />
      {isKSAProfessional() || !IS_SA ? <a onClick={() => {
        onClose(true);
      }} className="underline hover:no-underline !text-sm" href={buildLocalizeRoute(`${AppRoutes.Investor}/${AppRoutes.Profile}`)}>
        {t('reUploadDocuments')}
      </a> : null}
    </Box>;
  };

  return (
    <DialogWrapper
      maxWidth={loading ? 'xs' : isWinddown ? 'xs' : isAllDocUploaded ? 'xs' : 'md'}
      state={state}
      title={loading ? '' : getTitle()}
      onClose={() => {
        onClose(true);
      }}
      content={
        <Box>
          {!loading ? <>
            <Box className="flex flex-col justify-center">
              {isWinddown ? <Box>
                <Box className='flex flex-col w-full items-center justify-center space-y-2'>
                  {isWinddownDocsUploaded ? documentCompletedTemplate() : getCommonTemplete()}
                </Box>
              </Box> : !isAllDocUploaded ?
                <Box>
                  <TextWrapper classList="!text-center" text={t('nonApprovedUserDocumentDeposit')} />
                  <Box className='mt-4'>
                    <InvestorDocuments onAllUploaded={() => {
                      getDocumentUploadStatus();
                    }} investorType={investorDetails?.investorType?.name} hideHeading bodyClassList="!p-0" classList="!shadow-none" />
                  </Box>
                </Box>
                :
                documentCompletedTemplate()
              }
            </Box></> :
            <Box className='flex justify-center items-center min-h-[100px]'>
              <CircularProgress />
            </Box>
          }
        </Box>
      }
    ></DialogWrapper>
  );
};